import aclName from '../../../../../acl/AclName';
import action from '../../../../abstract/action';

export default action({
  label: 'Podgląd',
  icon: 'EditIcon',
  main: ({ item }) => true,
  render: ({ item, aclHave }) => {
    if (!item?.is_base) {
      return false;
    }

    if (aclHave(aclName.SettingsPageBasePriceListsEdit)) {
      return false;
    }

    return true;
  },
  handle: async ({ $router, item }) => await $router.push({
    name: 'admin-price-lists-list', params: { id: item.id },
  }),
});
